<div
  class="add-new-chart-button"
  [class.add-new-chart-button-disabled]="disabled"
  (click)="openChartList()"
  statistic
  [statisticElementName]="'Chart selector open chart list'"
  [ivLiveHint]="locale.addNewChart"
  ivLiveHintPosition="top-right"
>
  <span class="add-new-chart-button__text">{{locale.addNewChart}}</span>
</div>

<div
  class="chart-list-items"
  *ngIf="isChartListOpened"
  [disabled]="disabled"
  ngDefaultControl
  [(ngModel)]="selectedChart"
>
  <div
    class="chart-item"
    *ngFor="let chartEntity of listChartTypes"
    (click)="selectChart(chartEntity)"
    statistic
    [statisticElementName]="'Chart selector select chart'"
  >
    {{getChartName(chartEntity)}}
    <div class="chart-item__divider"></div>
  </div>
</div>
